import List from 'list.js';

export function yummy() {
  const list = document.querySelector('.archive-yummy');
  if(list) {
    const yummyList = new List(list, {
      valueNames: [
        { name: 'genre', attr: 'data-name' },
        { name: 'day', attr: 'data-name' },
        { name: 'name', attr: 'data-name' },
        'search-text'
      ]
    });

    const countEl = list.querySelector('.yummy-count');
    const updateCount = function() {
      if(countEl) {
        const visibleCount = yummyList.visibleItems.length;
        const template = (typeof fabfLabels !== 'undefined' && fabfLabels.yummyCount) ? fabfLabels.yummyCount : '%d';
        countEl.textContent = template.replace('%d', visibleCount);
      }
    };

    yummyList.on('searchComplete', updateCount);
    yummyList.on('filterComplete', updateCount);

    yummyList.sort('name', { order: "asc" });
    const nameSort = list.querySelector('.sort[data-sort="name"]');
    if(nameSort) nameSort.classList.add('asc');

    const normalize = function(str) {
      return (str || '').normalize('NFKC').toLowerCase();
    };

    const searchInput = list.querySelector('.search-input');
    if(searchInput) {
      searchInput.addEventListener('input', function() {
        const query = normalize(this.value.trim());
        if(!query) {
          yummyList.filter();
          yummyList.search();
          updateCount();
          return;
        }
        yummyList.filter(function(item) {
          return normalize(item.values()['search-text']).indexOf(query) !== -1;
        });
        updateCount();
      });
    }

    const viewToggles = list.querySelectorAll('.view-toggle');
    const listEl = list.querySelector('.list');
    const STORAGE_KEY = 'yummy-view';

    var setView = function(view) {
      listEl.classList.remove('view-list', 'view-grid');
      listEl.classList.add('view-' + view);
      viewToggles.forEach(function(t) {
        t.classList.toggle('active', t.dataset.view === view);
      });
      try { localStorage.setItem(STORAGE_KEY, view); } catch(e) {}
    };

    viewToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        setView(this.dataset.view);
      });
    });
  }
}
